var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 43.486,
    viewBox: "0 0 120 43.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Oktion_Logo",
    "data-name": "Oktion Logo",
    transform: "translate(-1.4 -1.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(57.166 3.683)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 0.72,
    height: 37.22,
    fill: "#636569"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(69.996 15.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M174.028,42.583a8.338,8.338,0,0,1-.635,3.387,4.793,4.793,0,0,1-1.863,2.2,5.5,5.5,0,0,1-5.589,0,4.793,4.793,0,0,1-1.863-2.2,7.3,7.3,0,0,1-.677-3.3v-.974a7.808,7.808,0,0,1,.677-3.387,4.907,4.907,0,0,1,1.863-2.244,5.5,5.5,0,0,1,5.589,0,4.907,4.907,0,0,1,1.863,2.244,8.481,8.481,0,0,1,.635,3.387Zm-1.736-.847a5.794,5.794,0,0,0-.932-3.6,3.392,3.392,0,0,0-5.293,0,5.687,5.687,0,0,0-.974,3.514v.974a6.049,6.049,0,0,0,.974,3.6,3.049,3.049,0,0,0,2.625,1.313,3.14,3.14,0,0,0,2.625-1.228,5.932,5.932,0,0,0,.974-3.557Z",
    transform: "translate(-163.4 -34.792)",
    fill: "#636569"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M196.852,43.5l-1.059,1.1v3.472H194.1V34.1h1.694v8.469l.889-1.1,3.049-3.26h2.032l-3.853,4.107,4.277,5.716H200.2Z",
    transform: "translate(-181.101 -34.1)",
    fill: "#636569"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M217.072,38.2v2.371h1.821v1.313h-1.821v6.1a1.389,1.389,0,0,0,.254.889.982.982,0,0,0,.847.3,3.42,3.42,0,0,0,.8-.127v1.355a4.658,4.658,0,0,1-1.313.169,2.031,2.031,0,0,1-1.694-.677,2.971,2.971,0,0,1-.593-1.948V41.884H213.6V40.571h1.778V38.2h1.694Z",
    transform: "translate(-192.344 -36.464)",
    fill: "#636569"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M230.8,36.374a.962.962,0,0,1,.254-.677,1.051,1.051,0,0,1,.762-.3.906.906,0,0,1,.762.3,1.03,1.03,0,0,1,0,1.355,1.27,1.27,0,0,1-1.524,0A.962.962,0,0,1,230.8,36.374Zm1.821,12.449h-1.694V39h1.694Z",
    transform: "translate(-202.261 -34.85)",
    fill: "#636569"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M240.342,48.5a5.648,5.648,0,0,1,.55-2.583,4.166,4.166,0,0,1,3.9-2.414,4.167,4.167,0,0,1,3.26,1.4,5.283,5.283,0,0,1,1.228,3.726v.127a5.648,5.648,0,0,1-.55,2.583,4.278,4.278,0,0,1-1.567,1.778,4.414,4.414,0,0,1-2.371.635,4.167,4.167,0,0,1-3.26-1.4,5.243,5.243,0,0,1-1.228-3.684V48.5Zm1.694.169a4.121,4.121,0,0,0,.762,2.625,2.489,2.489,0,0,0,2.032.974,2.414,2.414,0,0,0,2.032-1.016,4.614,4.614,0,0,0,.762-2.837,4.2,4.2,0,0,0-.762-2.625,2.414,2.414,0,0,0-2.032-1.016,2.547,2.547,0,0,0-2.032.974A5.072,5.072,0,0,0,242.036,48.666Z",
    transform: "translate(-207.738 -39.52)",
    fill: "#636569"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M268.051,43.612l.042,1.228a3.67,3.67,0,0,1,2.964-1.44c2.075,0,3.133,1.186,3.133,3.514v6.521H272.5V46.914a2.112,2.112,0,0,0-.508-1.567,1.964,1.964,0,0,0-1.482-.508,2.4,2.4,0,0,0-1.44.423,3.193,3.193,0,0,0-.974,1.143v7.029H266.4V43.612Z",
    transform: "translate(-222.787 -39.462)",
    fill: "#636569"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M21.979,1.1A20.544,20.544,0,0,0,10.123,38.447l.127,6.14,4.869-3.557A20.551,20.551,0,1,0,21.979,1.1ZM28.5,22.695a6.463,6.463,0,0,1-2.541,4.234,7,7,0,0,1-1.948.974,6.755,6.755,0,0,1-2.922.212,5.4,5.4,0,0,1-1.186-.3l-2.625,1.44.169-2.922a3.957,3.957,0,0,1-.677-.762,6.386,6.386,0,0,1-1.313-4.742A6.463,6.463,0,0,1,18,16.6a6.616,6.616,0,0,1,4.869-1.186,6.76,6.76,0,0,1,4.361,2.5h0A6.327,6.327,0,0,1,28.5,22.695Z",
    transform: "translate(0 0)",
    fill: "#ffc629"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.42b75010750572c5e86afc3459eef2e2.svg";
export { ForwardRef as ReactComponent };